import { apiResolverApi, useStaff } from "@gymflow/api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useMemo, useState } from "react";

import { usePortalRoutes } from "../../hooks/usePortalRoutes";
import { useRememberMe } from "../../hooks/useRememberMe";
import { ApiResolverContext } from "../../providers/ApiResolverProvider/ApiResolverContext";
import { AuthenticationContext } from "../../providers/authentication/AuthenticationContext";
import { RouteLayout } from "../../routes/layout";
import useGymflowModels from "../../store";
import { PaginatedSelect } from "./PaginatedSelect";

export interface NavigateToClubSelectProps {}
export function NavigateToClubSelect() {
  const { brand, routeId, createNewClubLink } = usePortalRoutes();
  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);

  const repository = useMemo(() => apiResolverApi, []);
  const getClubs = useMutation({
    mutationFn: ({ searchTerm, page, limit, clubId }: any) =>
      repository.findRoutes({
        search: searchTerm,
        page,
        limit,
        brand,
        clubId,
      }),
  });

  const { userId: loggedInId } = useContext(AuthenticationContext);

  const { data: currentStaff }: any = useStaff({ api, staffId: loggedInId });

  const [currentOption, setCurrentOption] = useState({ label: "---" });
  useEffect(() => {
    const fetchCurrentClub = async () => {
      const { results } = await getClubs.mutateAsync({
        page: 0,
        limit: 1,
        clubId: clubId.toString(),
      });
      if (results.length > 0) {
        setCurrentOption({ label: results[0].displayName });
      }
    };
    fetchCurrentClub();
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId]);

  const { rememberRoute } = useRememberMe();

  return (
    <PaginatedSelect
      className="[&_div]:text-primary-700 h-full !rounded-none border-y-0 border-l border-r-0 border-gray-300 p-0"
      value={{
        ...currentOption,
        label: currentOption.label,
      }}
      onChange={({ value }: any) => {
        rememberRoute(value.routeId);

        // eslint-disable-next-line react-compiler/react-compiler
        window.location.href = createNewClubLink(
          value.routeId,
          RouteLayout.Staff,
        );
      }}
      cacheUniqs={[currentStaff?.accessibleClubIds]}
      loadOptions={async (searchTerm: string, _: any, { page }: any) => {
        const clubId = currentStaff?.accessibleClubIds.join(",");
        const data = await getClubs.mutateAsync({
          searchTerm,
          page,
          limit: 10,
          clubId,
        });

        return {
          options: data.results.map((route) => ({
            label: route.displayName,
            value: route,
            isDisabled:
              route.status === "DISABLED" || route.routeId === routeId,
          })),
          hasMore: data.hasMore,
          additional: {
            page: page + 1,
          },
        };
      }}
    />
  );
}
